import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ObjectCacherService {
    fiveMinutes = 1000 * 60 * 5;
    cache: {
        [key: string]: any;
    } = {};
    killTimers: {
        [key: string]: number;
    } = {};

    get(id: string): any {
        return this.cache[id];
    }

    getAsPromise(id: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const response = this.get(id);
            if (response) {
                resolve(response);
            } else {
                reject(response);
            }
        });
    }

    put(id: string, obj: any) {
        this.cache[id] = obj;
        if (this.killTimers[id]) {
            clearTimeout(this.killTimers[id]);
        }
        this.killTimers[id] = window.setTimeout(() => {
            delete this.cache[id];
        }, this.fiveMinutes);
    }
}
